import { Observable } from "rxjs";
import { StateService } from "./stateService";

export interface InfoState {
    infoTitle: string;
    infoText: string
    isInfo: boolean;
  }
  
const initialState: InfoState = {
    infoTitle: "",
    infoText: "",
    isInfo: false,
  };

export function CreateUserInfo(title: string, content: string) : InfoState {
    return {
        infoTitle: title,
        infoText: content,
        isInfo: true
    }
}




export class InfoStateServiceForRoot extends StateService<InfoState>{
    public static service: InfoStateServiceForRoot;

    public static getInfoStateService() : InfoStateServiceForRoot {
        if ( this.service === undefined) {
            this.service = new InfoStateServiceForRoot();
        }
        return this.service;
    }

    private constructor() {
        super(initialState);
    }
    
    public subscription(): Observable<InfoState> {
        return this.subscribe();
    }

    public changeInfoState(error: InfoState) : void {
        this.changeState(error);
    }

    public resetInfoState() : void {
        const info = {
            infoTitle: "",
            infoText: "",
            isInfo: false
        }

        this.changeState(info);
    }

    public get InfoState(): InfoState {
        return this.state;
    }
}